import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EThresholdTypes = {
	min: 'min',
	max: 'max',
} as const;

export type TThresholdTypes = TValueOfStringRecord<typeof EThresholdTypes>

export enum ESaveTypeId {
	saveNew = 'saveNew',
	saveEdited = 'saveEdited'
}
